export const SCOOTER = 'scooter'
export const ACCIDENT_INSURANCE = 'accidentInsurance'

export const ALL_AB_TESTS = [
  SCOOTER,
  ACCIDENT_INSURANCE,
] as const

export type AbTest = typeof ALL_AB_TESTS[number]
